import { useDispatch, useSelector } from 'react-redux';
// import Alert from '@material-ui/lab/Alert';
import { Alert, Snackbar } from '@mui/material';

import { hideToast } from '../../store/slices/generalSlice';
import { RootState } from '../../store/rootReducer';

const Toast = () => {
  const toast = useSelector((state: RootState) => state.general.toast);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(hideToast());
  };

  return (
    <Snackbar open={toast.open} autoHideDuration={toast.autoHideDuration ?? 5000} onClose={handleClose}>
      <Alert elevation={6} variant="filled" onClose={handleClose} severity={toast.severity}>
        {toast.message}
      </Alert>
    </Snackbar>
  );
};

export default Toast;
